<template>
  <div>
    <div v-if="subscriptionExpired" class="alert alert-danger trial-popup desktop" role="alert">
      {{$t('trial_subscription_expired')}} <router-link to="/subscription" class="text-decoration-underline">{{$t('trial_subscription_upgrade_now')}}</router-link>.
    </div>
    <div v-else-if="showTrialPopup" class="alert alert-danger trial-popup desktop" role="alert">
      {{$t('trial_subscription_on_trial_1')}} <router-link to="/subscription" class="text-decoration-underline">{{$t('trial_subscription_upgrade_now')}}</router-link> {{$t('trial_subscription_on_trial_2')}}
    </div>

    <router-view />

    <div v-if="peerCalling && !peerCalling.started" class="peer-calling">
      <h3>{{ peerCalling.name }} {{$t('is_calling')}}</h3>

      <div class="d-flex gap-2">
        <a id="btn-password-close" class="btn btn-secondary btn-block" :aria-label="$t('close')" @click.prevent="cancelCall">
          <i class="feather-x me-1"></i>{{$t('decline')}}
        </a>

        <a class="btn btn-primary btn-block" @click.prevent="answerCall">
          <i class="feather-check me-1"></i>{{$t('answer')}}
        </a>
      </div>
    </div>

    <div v-if="showJoinRoom" class="peer-calling">
      <h3>Video Chat</h3>

      <div class="d-flex gap-2">
        <a class="btn btn-secondary btn-block" :aria-label="$t('close')" @click.prevent="VideoChatCall('decline')">
          <i class="feather-x me-1"></i>{{$t('decline')}}
        </a>

        <a class="btn btn-primary btn-block" @click.prevent="VideoChatCall('join')">
          <i class="feather-check me-1"></i>{{$t('join')}}
        </a>
      </div>
    </div>

    <div v-if="showRefused" class="peer-calling">
      <h3>{{$t('call_declined')}}</h3>
    </div>

    <audio id="call-audio" type="audio/mpeg" class="hidden d-none"></audio>

    <chat-modal v-if="currentChatUser"/>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import CallAudio from './assets/call-audio.mp3';
import ChatModal from "@/components/frontend/modal/chat-modal.vue";

export default {
  components: {ChatModal},

  mounted() {
    this.$eventHub.$on('VideoChatCall', this.ShowVideoChatCall);
    this.$eventHub.$on('PeerHandshake', this.onPeerHandshake);
    this.$eventHub.$on('PeerConnectionClosed', this.cancelCall);
    this.$eventHub.$on('PeerRefuseHandshake', this.gotRefused);

    if (document.querySelector('#call-audio')) {
      document.querySelector('#call-audio').src = CallAudio;
    }
  },

  unmounted() {
    this.$eventHub.$off('VideoChatCall', this.ShowVideoChatCall);
    this.$eventHub.$off('PeerHandshake', this.onPeerHandshake);
    this.$eventHub.$off('PeerConnectionClosed', this.cancelCall);
    this.$eventHub.$off('PeerRefuseHandshake', this.gotRefused);
  },

  computed: {
    ...mapGetters({
      operatorUsers: 'chat/internalUsers',
      currentUser: 'auth/user',
      currentChatUser: 'chat/currentChatUser',
      subscriptionExpired: 'subscriptions/expired',
      conversations: 'chat/conversations',
      conversationsForUserId: 'chat/conversationsForUserId',
      peerState: 'chat/peerState',
    }),

    showTrialPopup() {
      if (this.$store.getters['isOperator']) {
        return false;
      }

      return this.currentUser && this.currentUser.subscription && this.currentUser.subscription.plan.name.toLowerCase() === 'trial'
        && [
          'home',
          'chats',
          'settings',
          'discover',
          'profile',
          'subscription',
          'user-profile',
        ].includes(this.$route.name);
    },
  },

  data() {
    return {
      joinConversationId: null,
      joinForUserId: null,
      showJoinRoom: false,
      peerCalling: null,
      showRefused: false,
      videoChatWithUserId: null,
    };
  },

  methods: {
    gotRefused() {
      this.showRefused = true;
      this.$eventHub.$emit('VideoCallDeclined');

      setTimeout(() => {
        this.showRefused = false;
      }, 2000);
    },

    cancelCall() {
      if (this.currentChatUser && this.peerCalling) {
        window.Peer.peer(this.currentChatUser.id).refuse(this.currentChatUser.id);
      }

      this.videoChatWithUserId = null;
      this.peerCalling = null;
    },

    answerCall() {
      const conversation = this.conversations.find(e => e.user.id === this.videoChatWithUserId);
      if (!conversation) {
        return;
      }

      this.OpenVideoCallPage(conversation);

      // window.Peer.peer(this.currentChatUser.id).accept(this.videoChatWithUserId);
      // this.$router.push({name: 'chat-conversation', params: {id: conversation.user.username}});
      // this.$eventHub.$emit('StartCall');
      //
      // this.peerCalling.started = true;
    },

    ShowVideoChatCall({conversation_id, content, to_user_id, user_id}) {
      console.log('CALL MESSAGE', conversation_id, content)
      this.joinConversationId = conversation_id;
      this.joinForUserId = to_user_id;

      if (content === 'call') {
        this.$router.push(`/videochat/${conversation_id}`)
      } else if (content === 'decline') {
        this.gotRefused();
      } else if (content === 'join') {
        this.$eventHub.$emit('StartVideoCall', {room_id: this.joinConversationId, current_user: false, user_id, current_user_id: to_user_id})
      } else if (content === 'end') {
        this.$eventHub.$emit('EndVideoCall')
      }
    },

    async VideoChatCall(action) {
      const conversation = this.conversationsForUserId(this.joinForUserId).find(e => e.id === this.joinConversationId);
      if (!conversation) {
        console.log('No conversation found.');
        this.showJoinRoom = false;
        return;
      }

      this.showJoinRoom = false;

      await this.$store.dispatch('chat/sendMessage', {
        user_id: this.joinForUserId, // Current user
        to_user_id: conversation.user.id,
        conversationId: conversation.id,
        type: 'call',
        content: action,
      });

      if (action === 'decline') {
        this.joinConversationId = null;
      } else if (action === 'join') {
        this.$eventHub.$emit('StartVideoCall', {room_id: conversation.id, current_user: true, user_id: conversation.user.id, current_user_id: this.joinForUserId})
      }
    },

    OpenVideoCallPage(conversation) {
      this.$store.dispatch('chat/sendMessage', {
        user_id: this.currentChatUser.id,
        to_user_id: conversation.user.id,
        conversationId: conversation.id,
        type: 'call',
        content: 'call',
      }).then(r => {
        this.peerCalling = false;
      });

      this.$router.push(`/videochat/${conversation.id}`)
    },

    onPeerHandshake({peer, userId, localPeerId}) {
      this.videoChatWithUserId = userId;
      console.log('onPeerHandshake', {localPeerId, peer, userId}, this.currentChatUser)
      this.peerCalling = null;

      if (!this.currentChatUser && localPeerId) {
        const user = this.operatorUsers.find(e => e.id === localPeerId);
        if (user) {
          this.$store.commit('chat/setCurrentChatUser', user);
        }
      }

      if (!this.currentChatUser || this.peerState !== 'handshake') {
        return;
      }

      if (!this.currentChatUser) {
        return;
      }

      const conversation = this.conversations.find(e => e.user.id === this.videoChatWithUserId);

      this.peerCalling = {
        name: conversation?.user.profile.display_name,
      };
    },
  },
}
</script>

<style>
.peer-calling {
  width: 100%;
  height: 100%;
  background: #b0666694;
  z-index: 9999;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 16px;
}

.peer-calling h3 {
  padding: 10px 16px;
  border-radius: 18px;
  font-size: 2em;
  background: transparent;
  color: #000;
}

.peer-calling a {
  max-width: 200px;
}
</style>
